import React, { useState } from "react";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { motion } from "framer-motion";

const Accordion = ({ item }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="mb-4 border rounded-[24px] relative transition-all duration-500"
      style={{
        backgroundColor: isExpanded ? "#1F1F50" : "#493ED3",
        color: "white",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="my-4 font-noto-sans-armenian text-[18px] font-semibold leading-normal w-full flex justify-between items-center px-4 py-2"
      >
        <span className="text-[18px] text-left w-2/3" href={item?.link || ""}>
          {item.title}
        </span>
        <motion.div
          className="absolute right-[24px] w-[60px] h-[60px] rounded-[16px] bg-[#AED944] flex items-center justify-center text-black"
          initial={{ x: 0 }}
          animate={{ x: hovered ? 54 : 0 }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 20,
          }}
        >
          <motion.div
            initial={{ rotate: 0 }}
            animate={{ rotate: isExpanded ? 180 : 0 }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 20,
            }}
          >
            {isExpanded ? (
              <AiOutlineMinus size={24} />
            ) : (
              <AiOutlinePlus size={24} />
            )}
          </motion.div>
        </motion.div>
      </button>
      <motion.div
        className="bg-gray-100 px-4 flex flex-col rounded-b-lg overflow-hidden"
        initial={{ height: 0 }}
        animate={{ height: isExpanded ? "auto" : 0 }}
        transition={{
          type: "tween",
          duration: 0.3,
        }}
      >
        {isExpanded && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="py-2"
          >
            {item.content}
          </motion.div>
        )}
      </motion.div>
    </div>
  );
};

export default Accordion;
